<div class="modal-header mfa-app-modal-header">
  <div class="mfa-app-modal-heading">
    <img class="mfa-auth-app-icon mfa-app-modal-icon" [src]="app.iconUrl" [alt]="app.name + ' app icon'" width="44" height="44">
    <div>
      <h5 class="modal-title mfa-app-modal-title">Install {{ app.name }} on your phone</h5>
      <p class="mfa-app-modal-copy">
        Install it on the phone you'll use to sign in.
      </p>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body mfa-app-modal-body">
  <div class="mfa-app-modal-phone-step">
    <p class="mfa-app-modal-step-label">On your phone, open your app store and search for</p>
    <p class="mfa-app-modal-search-term">{{ app.name }}</p>
  </div>

  <p class="mfa-app-modal-secondary-copy">
    Already viewing this on your phone? Use the official store button:
  </p>

  <div class="mfa-app-modal-actions">
    <a class="mfa-store-badge mfa-store-badge-ios" [href]="app.iosUrl" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'Download ' + app.name + ' on the App Store'">
      <img class="mfa-store-badge-image" [src]="appStoreBadgeUrl" alt="Download on the App Store">
    </a>
    <a class="mfa-store-badge mfa-store-badge-android" [href]="app.androidUrl" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'Get ' + app.name + ' on Google Play'">
      <img class="mfa-store-badge-image" [src]="googlePlayBadgeUrl" alt="Get it on Google Play">
    </a>
  </div>

  <p class="mfa-app-modal-note">After installing the app, return to this setup window.</p>
</div>

<div class="modal-footer mfa-app-modal-footer">
  <button type="button" class="btn btn-primary w-100" (click)="activeModal.dismiss()">Back to setup</button>
</div>
